import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--companies-form"
export default class extends Controller {
  static targets = ["form", "databaseName", "submit", "userSection"]

  edit(event) {
    const row = event.currentTarget
    const url = row.dataset.url
    Turbo.visit(url, { frame: "admin-company-form" })
  }
}
